export default __webpack_public_path__ + "e82399f4b0bc0253b508a6d67452e5f1.png";